import Joi from "joi";

const BloodGroupMasterSchema = Joi.object({
  bloodGroupName: Joi.string()

    .valid("A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-")
    .required()
    .messages({
      "any.only":
        "Invalid blood group. Allowed values: A+, A-, B+, B-, AB+, AB-, O+, O-",
      "string.empty": "Blood group is required.",
    }),
}).unknown(true);

export default BloodGroupMasterSchema;
